export default __webpack_public_path__ + "static/media/scan-svgrepo-com.2cc4954b.svg";